import imagePhone1 from "../../src/assets/imagesPhones/imgPhone1.png";
import imagePhone2 from "../../src/assets/imagesPhones/imgPhone2.png";
import imagePhone3 from "../../src/assets/imagesPhones/imgPhone3.png";
import imagePhone4 from "../../src/assets/imagesPhones/imgPhone4.png";
import imagePhone5 from "../../src/assets/imagesPhones/imgPhone5.png";
import imagePhone6 from "../../src/assets/imagesPhones/imgPhone6.png";
import imagePhone7 from "../../src/assets/imagesPhones/imgPhone7.png";
import imagePhone8 from "../../src/assets/imagesPhones/imgPhone8.png";

import imageTablet1 from "../../src/assets/imagesTablet/imgTablet1.png";
import imageTablet2 from "../../src/assets/imagesTablet/imgTablet2.png";
import imageTablet3 from "../../src/assets/imagesTablet/imgTablet3.png";
import imageTablet4 from "../../src/assets/imagesTablet/imgTablet4.png";
import imageTablet5 from "../../src/assets/imagesTablet/imgTablet5.png";
import imageTablet6 from "../../src/assets/imagesTablet/imgTablet6.png";
import imageTablet7 from "../../src/assets/imagesTablet/imgTablet7.png";
import imageTablet8 from "../../src/assets/imagesTablet/imgTablet8.png";

// \u00A0 is a non-breaking space for the emoji

export const firstPageStories = [
  {
    id: 1,
    name: "image1",
    img: imagePhone1,
    imgTablet: imageTablet1,
    title: `Stop Guessing, Start Dominating`,
    content: `Connect your fantasy leagues and let RotoGPT’s AI agents work 24/7 to find your winning edge.`,
  },
  {
    id: 2,
    name: "image2",
    img: imagePhone2,
    imgTablet: imageTablet2,
    title: `Your AI Co-Manager with No Filter`,
    content: `Get blunt, data-driven advice on how to fix your roster, target trades, and climb the standings.`,
  },
  {
    id: 3,
    name: "image3",
    img: imagePhone3,
    imgTablet: imageTablet3,
    title: `Team Analysis For Every League`,
    content: `Identify roster bottlenecks and trade value gaps. Know who's helping you and who's taking up space.`,
  },
  {
    id: 4,
    name: "image4",
    img: imagePhone4,
    imgTablet: imageTablet4,
    title: `Win Every Trade Negotiation`,
    content: `Evaluate player values in real-time and execute trades that set your team up for a dynasty.`,
  },
  {
    id: 5,
    name: "image5",
    img: imagePhone5,
    imgTablet: imageTablet5,
    title: `The Perfect Lineup, Every Week`,
    content: `RotoGPT calculates millions of data points to project your final score.`,
  },
  // {
  //   id: 6,
  //   name: "image6",
  //   img: imagePhone6,
  //   imgTablet: imageTablet6,
  //   title: `Who’s on Top?`,
  //   content: `Check player rankings and find the best options to strengthen your team.`,
  // },
  // {
  //   id: 7,
  //   name: "image7",
  //   img: imagePhone7,
  //   imgTablet: imageTablet7,
  //   title: `Smart Waiver Picks!`,
  //   content: `Discover the best available players in your league before anyone else`,
  // },
  // {
  //   id: 8,
  //   name: "image8",
  //   img: imagePhone8,
  //   imgTablet: imageTablet8,
  //   title: `🚀\u00A0  Let’s Win This Season!`,
  //   content: `Explore RotoGPT and take your Fantasy Football experience to the next level.`,
  // },
];
